







































import { Component, Vue, Watch, Ref, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { BoardActionsKeys, BoardActionsPayload, Label } from '@/store/types/board';

@Component({})
export default class EditLabel extends Vue {
  @Action(BoardActionsKeys.EDIT_LABEL) editLabel!: (payload: BoardActionsPayload['EDIT_LABEL']) => Promise<void>;
  @Prop(Object) label!: Label;

  @Ref('editLabelForm') labelForm!: Vue;

  dialog = false;
  validLabelForm = true;

  labelName = '';

  @Watch('dialog')
  setNewLabel() {
    this.labelName = this.label.name;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (this.labelForm) (this.labelForm as any).resetValidation();
  }

  labelDataValidations = {
    name: [(v: string) => !!v || 'Label name is required'],
  };

  async editNewLabel() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((this.labelForm as any).validate()) {
      await this.editLabel({ labelId: this.label.id, name: this.labelName });
      this.dialog = false;
    }
  }
}
